import GetAppSystemCustomFieldsRequestModelBase from '../_generated/modelBases/get-app-system-custom-fields-request-model-base';

export default class GetAppSystemCustomFieldsRequestModel extends GetAppSystemCustomFieldsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
